import React from "react";
import ZigzagDivider from "./ZigzagDivider";

const Resizer = ({ classes, onChangeWidth, onChangeWidthByClick }) => {
    let startPosition;

    const onMouseMove = (mouseMoveEvent) => {
        onChangeWidth(startPosition - mouseMoveEvent.pageX);
    }

    const onMouseUp = (_) => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }

    const onResizeClick = e => {
        e.preventDefault();

        startPosition = e.pageX;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    const onResizeDoubleClick = () => {
        onChangeWidthByClick(100);
    }

    return (
        <div className={classes.resizeHandle}
            onMouseDown={onResizeClick}
            onDoubleClick={onResizeDoubleClick}>

            <ZigzagDivider className={`resizerLine ${classes.resizerLine}`}/>
        </div>
    )
}

export default Resizer;